import Backbone from 'backbone';
import tpl from './class-money-template.hbs';

import { eventBus } from '../../state-manager/event-bus';

export var ClassMoneyView = Backbone.View.extend({
  tagName: 'div',

  template: tpl,

  initialize: function () {
    this.eventBus = eventBus;
    this.listenTo(this.model, 'change:resultText', this.render);
  },

  events: {
    'click [data-class-money-click=openMallClass]': 'openMallClass',
    'click [data-class-money-click=openMallGold]': 'openMallGold',
    'click [data-class-money-click=confirm]': 'confirm',
    'click [data-class-money-click=claim]': 'claim'
  },

  render: function () {
    var rendered = this.template(this.model.toJSON());
    this.$el.html(rendered);

    if (this.model.get('resultText') === 'success') {
      this.eventBus.trigger('app:refresh');
    }

    return this;
  },

  confirm: function (e) {
    e.preventDefault();
    this.remove();
  },

  openMallClass: function (e) {
    e.preventDefault();
    eventBus.trigger('open:mall', { to: 'pokerclass' });
    this.remove();
  },

  openMallGold: function (e) {
    e.preventDefault();
    this.eventBus.trigger('open:mall', { to: 'pokerclass/3' });
    this.remove();
  },

  claim: function (e) {
    e.preventDefault();
    this.model.claim();
    this.remove();
  }
});
